import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, CheckIcon, MailIcon } from 'lucide-react';
import { ProjectCarousel } from '../components/ProjectCarousel';
export function BrandingMarketing() {
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-844">
      {/* Header */}
      <header className="py-4 px-6 bg-white border-b border-stone-200" data-id="element-845">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-846">
          <Link to="/" className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-847">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-848" />
            <span className="font-light" data-id="element-849">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-850">Maria Elina</h1>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-10 px-6 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50" data-id="element-851">
        <div className="max-w-7xl mx-auto text-center" data-id="element-852">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-853">
            <h2 className="text-5xl md:text-7xl font-light text-stone-900 mb-4 flex flex-col items-center gap-2" data-id="element-854">
              <img src="https://storage.yandexcloud.net/maria-images/images/Marketing.svg" alt="Branding + Marketing" className="md:w-16 md:h-16 w-10 h-10" data-id="element-855" />
              Branding + Marketing
            </h2>
            <p className="text-xl text-stone-600 font-light max-w-2xl mx-auto" data-id="element-856">
              Strategic brand development and marketing campaigns that resonate
              with your audience and drive results
            </p>
          </motion.div>
        </div>
      </section>

      {/* Service Packages Section */}
      <section className="py-20 px-6 pt-[40px]" data-id="element-857">
        <div className="max-w-7xl mx-auto" data-id="element-858">
          {/* Section Header */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-16" data-id="element-859">
            <div className="relative inline-block" data-id="element-860">
              <h3 className="text-4xl md:text-5xl font-extralight text-stone-900 mb-6 tracking-tight" data-id="element-861">
                Service Packages
              </h3>
              <motion.div initial={{
              scaleX: 0
            }} whileInView={{
              scaleX: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              delay: 0.2
            }} className="absolute -bottom-2 left-0 right-0 h-[2px] bg-emerald-600" style={{
              clipPath: 'polygon(10% 0, 90% 0, 100% 100%, 0 100%)'
            }} data-id="element-862" />
            </div>
          </motion.div>

          {/* Full Package - Featured */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} whileHover={{
          y: -8
        }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 mb-8" style={{
          clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
        }} data-id="element-863">
            {/* Holographic gradient background */}
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/15 via-teal-400/15 to-cyan-400/15" data-id="element-864" />
            <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-865" />

            {/* Featured badge */}
            <div className="absolute top-3 right-3 md:top-6 md:right-6" data-id="element-866">
              <span className="inline-block px-2.5 py-1 text-xs md:px-4 md:py-1.5 md:text-sm font-light text-emerald-700 bg-emerald-100 rounded-full border border-emerald-200" data-id="element-867">
                Complete Solution
              </span>
            </div>

            <div className="relative z-10 p-10" data-id="element-868">
              <h4 className="text-3xl font-light text-stone-900 mb-8 tracking-tight" data-id="element-869">
                Full Package
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-870">
                {/* Brand Development */}
                <div data-id="element-871">
                  <h5 className="text-lg font-medium text-emerald-700 mb-4 tracking-wide" data-id="element-872">
                    Brand Development
                  </h5>
                  <ul className="space-y-3" data-id="element-873">
                    <li className="flex items-start gap-3" data-id="element-874">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-875" />
                      <span className="text-stone-700 font-light" data-id="element-876">
                        Visual branding and identity
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-877">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-878" />
                      <span className="text-stone-700 font-light" data-id="element-879">
                        Tone of voice
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-880">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-881" />
                      <span className="text-stone-700 font-light" data-id="element-882">
                        Styling guidelines
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-883">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-884" />
                      <span className="text-stone-700 font-light" data-id="element-885">
                        Brand templates
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Digital Marketing */}
                <div data-id="element-886">
                  <h5 className="text-lg font-medium text-emerald-700 mb-4 tracking-wide" data-id="element-887">
                    Digital Marketing Campaign Setup
                  </h5>
                  <ul className="space-y-3" data-id="element-888">
                    <li className="flex items-start gap-3" data-id="element-889">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-890" />
                      <span className="text-stone-700 font-light" data-id="element-891">
                        Google Ads setup
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-892">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-893" />
                      <span className="text-stone-700 font-light" data-id="element-894">
                        Social Media branded page setup
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-895">
                      <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-896" />
                      <span className="text-stone-700 font-light" data-id="element-897">
                        Campaign strategy and handover
                      </span>
                    </li>
                  </ul>
                  <p className="text-sm text-stone-500 font-light mt-4 italic" data-id="element-898">
                    *Excludes ongoing management
                  </p>
                </div>
              </div>

              {/* Enquire Button */}
              <div className="mt-10" data-id="element-899">
                <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Full%20Package%20%E2%80%93%20Branding%20%2B%20Marketing&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Full%20Package%2C%20which%20includes%3A%0D%0A%0D%0ABrand%20Development%3A%0D%0A%E2%80%A2%20Visual%20branding%20and%20identity%0D%0A%E2%80%A2%20Tone%20of%20voice%0D%0A%E2%80%A2%20Styling%20guidelines%0D%0A%E2%80%A2%20Brand%20templates%0D%0A%0D%0ADigital%20Marketing%20Campaign%20Setup%3A%0D%0A%E2%80%A2%20Google%20Ads%20setup%0D%0A%E2%80%A2%20Social%20Media%20branded%20page%20setup%0D%0A%E2%80%A2%20Campaign%20strategy%20and%20handover%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                y: -3
              }} className="group/btn inline-block relative" data-id="element-900">
                  <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                  clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                }} data-id="element-901" />
                  <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
                  clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                }} data-id="element-902">
                    <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-903" />
                    <span className="text-lg font-light relative z-10 inline-flex items-center gap-2" data-id="element-904">
                      <MailIcon className="w-4 h-4" data-id="element-905" />
                      Enquire
                    </span>
                  </div>
                </motion.a>
              </div>
            </div>

            {/* Angular corner accents */}
            <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-906" />
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-907" />
          </motion.div>

          {/* Other Packages Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-908">
            {/* Branding Package */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-909">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-910" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-911" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-912">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-913">
                  Branding Package
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-914">
                  <li className="flex items-start gap-3" data-id="element-915">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-916" />
                    <span className="text-stone-700 font-light" data-id="element-917">
                      Visual branding and identity development
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-918">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-919" />
                    <span className="text-stone-700 font-light" data-id="element-920">
                      Tone of voice
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-921">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-922" />
                    <span className="text-stone-700 font-light" data-id="element-923">
                      Styling guidelines
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-924">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-925" />
                    <span className="text-stone-700 font-light" data-id="element-926">
                      Brand templates
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-927">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-928" />
                    <span className="text-stone-700 font-light" data-id="element-929">
                      Marketing strategy proposal
                    </span>
                  </li>
                </ul>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-930">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Branding%20Package&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Branding%20Package%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Visual%20branding%20and%20identity%20development%0D%0A%E2%80%A2%20Tone%20of%20voice%0D%0A%E2%80%A2%20Styling%20guidelines%0D%0A%E2%80%A2%20Brand%20templates%0D%0A%E2%80%A2%20Marketing%20strategy%20proposal%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-931">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-932" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-933">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-934" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-935">
                        <MailIcon className="w-4 h-4" data-id="element-936" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-937" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-938" />
            </motion.div>

            {/* Branding Mini */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-939">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-940" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-941" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-942">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-943">
                  Branding Mini
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-944">
                  <li className="flex items-start gap-3" data-id="element-945">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-946" />
                    <span className="text-stone-700 font-light" data-id="element-947">
                      Logo design
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-948">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-949" />
                    <span className="text-stone-700 font-light" data-id="element-950">
                      Color palette
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-951">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-952" />
                    <span className="text-stone-700 font-light" data-id="element-953">
                      Typography selection
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-954">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-955" />
                    <span className="text-stone-700 font-light" data-id="element-956">
                      Mini brand guide
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-957">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-958" />
                    <span className="text-stone-700 font-light" data-id="element-959">
                      1 key template (e.g. Business Card)
                    </span>
                  </li>
                </ul>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-960">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Branding%20Mini&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Branding%20Mini%20package%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Logo%20design%0D%0A%E2%80%A2%20Color%20palette%0D%0A%E2%80%A2%20Typography%20selection%0D%0A%E2%80%A2%20Mini%20brand%20guide%0D%0A%E2%80%A2%201%20key%20template%20(e.g.%20Business%20Card)%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-961">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-962" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-963">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-964" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-965">
                        <MailIcon className="w-4 h-4" data-id="element-966" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-967" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-968" />
            </motion.div>

            {/* Digital Marketing Campaign Setup */}
            <motion.div initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} whileHover={{
            y: -8
          }} className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 h-full" style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 95%, 95% 100%, 0 100%)'
          }} data-id="element-969">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400/10 via-teal-400/10 to-cyan-400/10" data-id="element-970" />
              <div className="absolute inset-0 bg-gradient-to-tr from-cyan-300/5 via-emerald-300/5 to-teal-300/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-971" />

              <div className="relative z-10 p-8 h-full flex flex-col" data-id="element-972">
                <h4 className="text-2xl font-light text-stone-900 mb-6 tracking-tight" data-id="element-973">
                  Digital Marketing Setup
                </h4>
                <ul className="space-y-3 flex-grow" data-id="element-974">
                  <li className="flex items-start gap-3" data-id="element-975">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-976" />
                    <span className="text-stone-700 font-light" data-id="element-977">
                      Google Ads setup
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-978">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-979" />
                    <span className="text-stone-700 font-light" data-id="element-980">
                      Social media business pages setup
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-981">
                    <CheckIcon className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" data-id="element-982" />
                    <span className="text-stone-700 font-light" data-id="element-983">
                      Posts direction
                    </span>
                  </li>
                </ul>
                <p className="text-sm text-stone-500 font-light mt-4 italic" data-id="element-984">
                  *Excludes ongoing management
                </p>

                {/* Enquire Button */}
                <div className="mt-6" data-id="element-985">
                  <motion.a href="mailto:contact@maria-elina.com?subject=Enquiry%3A%20Digital%20Marketing%20Campaign%20Setup&body=Hi%20Maria%2C%0D%0A%0D%0AI'm%20interested%20in%20the%20Digital%20Marketing%20Campaign%20Setup%2C%20which%20includes%3A%0D%0A%E2%80%A2%20Google%20Ads%20setup%0D%0A%E2%80%A2%20Social%20media%20business%20pages%20setup%0D%0A%E2%80%A2%20Posts%20direction%0D%0A%0D%0ACould%20we%20arrange%20a%20time%20to%20discuss%20the%20details%3F%0D%0A%0D%0ABest%20regards%2C%0D%0A%5BYour%20Name%5D" whileHover={{
                  y: -2
                }} className="group/btn inline-block relative" data-id="element-986">
                    <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
                    clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
                  }} data-id="element-987" />
                    <div className="relative px-5 py-1.5 bg-transparent overflow-hidden mx-3 my-1.5" style={{
                    clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
                  }} data-id="element-988">
                      <div className="absolute inset-0 bg-emerald-600 translate-y-[-100%] group-hover/btn:translate-y-0 transition-transform duration-300" data-id="element-989" />
                      <span className="text-base font-light relative z-10 inline-flex items-center gap-2 text-emerald-600 group-hover/btn:text-white transition-colors duration-300" data-id="element-990">
                        <MailIcon className="w-4 h-4" data-id="element-991" />
                        Enquire
                      </span>
                    </div>
                  </motion.a>
                </div>
              </div>

              <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-992" />
              <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-emerald-600/0 group-hover:border-emerald-600/50 transition-colors duration-300" data-id="element-993" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Work Samples Section */}
      <section className="py-24 px-6 bg-white border-t border-stone-100" data-id="element-994">
        <div className="max-w-7xl mx-auto" data-id="element-995">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-center mb-20" data-id="element-996">
            <h3 className="text-4xl md:text-5xl font-extralight text-stone-900 mb-6 tracking-tight" data-id="element-997">
              Work Samples
            </h3>
            <div className="w-24 h-[1px] bg-emerald-600 mx-auto" data-id="element-998" />
          </motion.div>

          {/* Project 1: Re-Novation NL */}
          <div className="mb-32" data-id="element-999">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-12" data-id="element-1000">
              <h4 className="text-3xl md:text-4xl font-light text-stone-900 mb-3" data-id="element-1001">
                Re-Novation NL
              </h4>
              <p className="text-emerald-700 font-medium mb-6 tracking-wide uppercase text-sm" data-id="element-1002">
                Branding Mini and Google Ads
              </p>
              <p className="text-lg text-stone-600 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-1003">
                Re-Novation is a project coordination company focused on
                reducing stress and friction for high-end clients in their
                renovation projects.
              </p>
            </motion.div>

            <ProjectCarousel slides={[{
            image: 'https://storage.yandexcloud.net/maria-images/images/Logo,%20Colour%20Palette%20&%20Typography.png',
            caption: 'Logo, Colours & Typography'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Ideation%20Process.png',
            caption: 'Ideation Process'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Google%20Ads%20Campaign%20Strategy.png',
            caption: 'Google Ads Campaign Strategy'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Templates%20Collateral.png',
            caption: 'Marketing Collateral Templates'
          }]} data-id="element-1004" />
          </div>

          {/* Project 2: BioMaxing */}
          <div data-id="element-1005">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-12" data-id="element-1006">
              <h4 className="text-3xl md:text-4xl font-light text-stone-900 mb-3" data-id="element-1007">
                BioMaxing
              </h4>
              <p className="text-emerald-700 font-medium mb-6 tracking-wide uppercase text-sm" data-id="element-1008">
                Tailored Full Package
              </p>
              <p className="text-lg text-stone-600 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-1009">
                Co-founded startup directing the brand identity, UX/UI design
                and marketing strategy for a multi-platform biohacking and
                wellness application.
              </p>
            </motion.div>

            <ProjectCarousel slides={[{
            image: 'https://storage.yandexcloud.net/maria-images/images/Logo,%20Colours%20&%20Typography%20Bio.png',
            caption: 'Ecosystem Logos & Styling'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Ideation%20Process%20Bio.png',
            caption: 'Ideation Process'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Social%20Media%20Campaign%20Bio.png',
            caption: 'Social Media Campaign Strategy'
          }, {
            image: 'https://storage.yandexcloud.net/maria-images/images/Web%20&%20Mobile%20Styling%20Bio.png',
            caption: 'Web & Mobile Styling'
          }]} data-id="element-1010" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-t from-emerald-50/40 via-stone-50 to-stone-50 border-t border-emerald-600/30" data-id="element-1011">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1012">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-1013">
            <h2 className="text-4xl md:text-5xl font-light mb-6 text-stone-900" data-id="element-1014">
              Have a specific request?
            </h2>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-1015">
              Let's discuss what we can create together
            </p>
            <motion.a href="mailto:contact@maria-elina.com" whileHover={{
            y: -3
          }} className="group inline-block relative" data-id="element-1016">
              {/* Outer border layer */}
              <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
              clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
            }} data-id="element-1017" />
              {/* Inner filled layer */}
              <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
              clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
            }} data-id="element-1018">
                <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300" data-id="element-1019" />
                <span className="text-lg font-light relative z-10 inline-flex items-center gap-2" data-id="element-1020">
                  <MailIcon className="w-4 h-4" data-id="element-1021" />
                  Get in Touch
                </span>
              </div>
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>;
}